import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-08130e47"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "ppc-section"
};
const _hoisted_2 = {
  key: 1,
  class: "text"
};
const _hoisted_3 = {
  key: 0,
  class: "title"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 1,
  ref: "content"
};
const _hoisted_6 = {
  key: 2,
  style: {
    "height": "100%"
  },
  ref: "content"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Coming soon", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_error_occured = _resolveComponent("error-occured");
  const _component_b_overlay = _resolveComponent("b-overlay");
  const _component_flex_column = _resolveComponent("flex-column");
  return _openBlock(), _createBlock(_component_flex_column, {
    gap: 24,
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(() => [$props.title || $props.subtitle || $props.icon ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$props.icon ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: $props.icon
    }, null, 8, ["icon"])) : _createCommentVNode("", true), $props.title || $props.subtitle ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($props.title), 1)) : _createCommentVNode("", true), $props.subtitle ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "subtitle",
      innerHTML: $props.subtitle
    }, null, 8, _hoisted_4)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $props.errorOccured ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_error_occured, {
      onRetry: $options.retryOnError
    }, null, 8, ["onRetry"])], 512)) : _createCommentVNode("", true), !$props.errorOccured ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_b_overlay, {
      show: $props.loading || $props.disabled,
      opacity: 0.4,
      rounded: "sm",
      style: _normalizeStyle({
        minHeight: $options.getOverlayHeight ?? '100%'
      })
    }, _createSlots({
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
      _: 2
    }, [$props.disabled ? {
      name: "overlay",
      fn: _withCtx(() => [_hoisted_7]),
      key: "0"
    } : undefined]), 1032, ["show", "style"])], 512)) : _createCommentVNode("", true)]),
    _: 3
  });
}